export default "__VITE_PUBLIC_ASSET__da4c138d__"